import ArrowRight16 from '@carbon/icons-react/es/arrow--right/16';
import { Col, DrawerProps, Row as AntRow, Space } from 'antd';
import React, { FC } from 'react';
import { withWizard, WizardComponentProps } from 'react-albus';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { StepId } from './steps';

const Row = styled(AntRow).attrs({ justify: 'space-between' })`
  width: 100%;
`;

type Props = Pick<DrawerProps, 'onClose'> & { isLoading?: boolean };
type StepFooterProps = Props & WizardComponentProps;

const StepFooter: FC<StepFooterProps> = ({
  wizard,
  onClose,
  isLoading = false,
}) => {
  const { step, next, previous } = wizard;
  const id = step.id as StepId;

  switch (id) {
    case 'Step1':
      return (
        <Row>
          <Col>
            <Button
              onClick={(e) =>
                onClose?.(e as React.MouseEvent<HTMLButtonElement>)
              }
            >
              <FormattedMessage id="cancel" />
            </Button>
          </Col>
          <Col>
            <Button
              iconPlacement="right"
              icon={<ArrowRight16 />}
              type="primary"
              onClick={next}
              loading={isLoading}
              data-cy="projects.phase.import.step1.ok_text"
            >
              <FormattedMessage id="projects.phase.import.step1.ok_text" />
            </Button>
          </Col>
        </Row>
      );
    case 'Step2':
      return (
        <Row>
          <Col>
            <Button
              onClick={(e) =>
                onClose?.(e as React.MouseEvent<HTMLButtonElement>)
              }
            >
              <FormattedMessage id="cancel" />
            </Button>
          </Col>
          <Col>
            <Space>
              <Button onClick={previous}>
                <FormattedMessage id="back" />
              </Button>
              <Button
                iconPlacement="right"
                type="primary"
                onClick={next}
                loading={isLoading}
                data-cy="projects.phase.import.step2.import"
              >
                <FormattedMessage id="import" />
              </Button>
            </Space>
          </Col>
        </Row>
      );
    default:
      return null;
  }
};

export const Footer = withWizard<Props>(StepFooter);
